import type {ObjectOptions} from './object-modified-event';

export const SIZE_AND_POSITION_PROPS: (keyof ObjectOptions)[] = [
  'fontSize',
  'fontFamily',
  'left',
  'top',
  'width',
  'height',
  'scaleX',
  'scaleY',
  'flipX',
  'flipY',
  'angle',
  'src',
  'strokeWidth',
];
